import usePendingState from '../../Hooks/usePendingState';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNotification } from '../../Contexts/NotificationContext';
import Loading from '../Loading';

const FormAddUser = () => {
    const { setNotification } = useNotification();
    const [loading, setLoading] = useState(true);
    const [userData, setuserData] = useState({
        nome: '',
        email: '',
        password: '',
    });

    const [userErrorData, setUserErrorData] = useState({
        nome: [],
        email: [],
        password: [],
    });

    const [formLoading, setFormLoading, formPendingRef] = usePendingState();

    const navigate = useNavigate();
    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setuserData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    useEffect(() => {
        setLoading(false);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formPendingRef.current) return;
        setFormLoading(true);

        try {
            const response = await fetch(`${baseUrl}/manager/usuarios/novo/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify(userData),
            });
            if (response.ok) {
                setNotification({
                    type: 'success',
                    message: 'Usuário adicionado com sucesso!',
                    show: true,
                });
                navigate('/manager/usuarios');
            } else {
                if (response.status === 422) {
                    const errors = await response.json();
                    setUserErrorData(errors);
                } else {
                    throw new Error('Erro ao adicionar novo usuario');
                }
            }
        } catch (error) {
            setNotification({
                type: 'error',
                message: error.message,
                show: true,
            });
        } finally {
            setFormLoading(false);
        }
    };

    if (loading)
        return (
            <div className="mx-auto py-20 flex justify-center">
                <div className="h-16 w-16 animate-spin rounded-full border-4 border-solid border-primary border-t-transparent"></div>
            </div>
        );

    return (
        <>
            <Link
                to="/manager/usuarios"
                className="bg-slate-100 px-4 py-1.5 rounded border border-slate-300 float-right ml-2 transition-all hover:bg-slate-200"
            >
                <FontAwesomeIcon icon={faArrowLeft} className="mr-2" />
                Voltar
            </Link>

            <h4 className="mb-6 text-xl font-bold text-black">Adicionar usuário</h4>

            <div className="flex flex-col">
                <form onSubmit={handleSubmit} className="max-w-5xl pb-10">
                    <div className="mb-6 2xl:mb-10">
                        <div className="mb-3 flex gap-5 flex-col lg:flex-row">
                            <div className="w-full lg:w-3/4">
                                <label className="block text-sm font-medium mb-1">Nome</label>
                                <input
                                    type="text"
                                    name="nome"
                                    value={userData.nome}
                                    onClick={() => setUserErrorData((prevData) => ({ ...prevData, nome: [] }))}
                                    onChange={handleChange}
                                    className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                />
                                {userErrorData.nome && userErrorData.nome[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {userErrorData.nome[0]}{' '}
                                        <span
                                            onClick={() => setUserErrorData((prevData) => ({ ...prevData, nome: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className="mb-3 flex gap-5 flex-col lg:flex-row">
                            <div className="w-1/3">
                                <label className="block text-sm font-medium mb-1">E-mail</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={userData.email}
                                    onClick={() => setUserErrorData((prevData) => ({ ...prevData, email: [] }))}
                                    onChange={handleChange}
                                    className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                />
                                {userErrorData.email && userErrorData.email[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {userErrorData.email[0]}{' '}
                                        <span
                                            onClick={() => setUserErrorData((prevData) => ({ ...prevData, email: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>

                            <div className="w-1/3">
                                <label className="block text-sm font-medium mb-1">Senha</label>
                                <input
                                    type="password"
                                    name="password"
                                    value={userData.password}
                                    onClick={() => setUserErrorData((prevData) => ({ ...prevData, password: [] }))}
                                    onChange={handleChange}
                                    className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                />
                                {userErrorData.password && userErrorData.password[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {userErrorData.password[0]}{' '}
                                        <span
                                            onClick={() => setUserErrorData((prevData) => ({ ...prevData, password: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>

                            <div className="w-1/6">
                                <label className="block text-sm font-medium mb-1">Ativo?</label>

                                <label className="cursor-pointer">
                                    <input
                                        type="checkbox"
                                        name="ativo"
                                        checked={userData.ativo}
                                        onChange={handleChange}
                                        className="sr-only peer"
                                    />
                                    <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-0 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-600"></div>
                                </label>

                                {userErrorData.ativo && userErrorData.ativo[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {userErrorData.ativo[0]}{' '}
                                        <span
                                            onClick={() => setUserErrorData((prevData) => ({ ...prevData, ativo: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>

                    <button
                        type="submit"
                        disabled={formLoading}
                        aria-busy={formLoading}
                        className="w-full lg:w-3/4 bg-secondary text-white py-2 px-4 rounded-md hover:bg-opacity-80 disabled:bg-opacity-80 disabled:cursor-not-allowed"
                    >
                        {!formLoading ? 'Salvar' : <Loading />}
                    </button>
                </form>
            </div>
        </>
    );
};

export default FormAddUser;
